export const Header = ({ title, count }: { title?: string; count?: number }) => {
  return (
    <div className='card-header border-0 pt-0'>
      <h3 className='card-title align-items-start flex-column'>
        <span className='card-label fw-bold fs-3'>
          Мэтчинг{title ? <>&nbsp;&raquo; {title}</> : ''}
          {!!count && " "}
          {!!count && <span className='text-muted fs-5'>({count})</span>}
        </span>
      </h3>
    </div>
  )
}